<template>
    <AppPage title="Meus Pedidos" subtitle="Veja os pedidos criados por você" :check-user-permission="false">
        <table class="table is-fullwidth is-striped is-middle">
            <thead>
            <tr>
                <th>Pedido</th>
                <th class="is-hidden-touch">Data</th>
                <th>Valor Total</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="order in orders" :key="order.id">
                <td>
                    <router-link :to="{name: 'orders.view', params: {id: order.id}}" class="list-link">
                        <div>{{ order.data.user.name }}</div>
                        <small>{{ order.data.number }}</small>
                    </router-link>
                </td>
                <td class="is-hidden-touch">{{ order.data.createdAt | moment('LLL') }}</td>
                <td>{{ order.data.totalPrice | money }}</td>
            </tr>
            </tbody>
        </table>
    </AppPage>
</template>

<script>

    import AppPage from "@/components/AppPage";
    import database from "@/services/database";
    import {mapGetters} from "vuex";
    
    export default {
        name: "userOrdersPage",

        components: {AppPage},

        data() {
            return {
                orders: []
            }
        },
        
        computed: {
            ...mapGetters(['user'])
        },

        created() {

            let loading = this.$buefy.loading.open();
            const user = this.user;

            this._unsubscriveOrdersSnapshots = database.collection('orders')
                .where('userId', '==', user.uid)
                .orderBy('createdAt', 'desc')
                .limit(200)
                .onSnapshot((spapshot) => {
                    const orders = []
                    spapshot.forEach(document => {
                        orders.push({
                            id: document.id,
                            data: document.data()
                        });
                    });

                    this.orders = orders;

                    if (loading) {
                        loading.close();
                    }
                })
        },

        beforeDestroy() {
            if (this._unsubscriveOrdersSnapshots) {
                this._unsubscriveOrdersSnapshots();
            }
        }
    }
</script>

